import { formatDateToMMDDYYYY } from '@src/utils/helpers';
import classNames from 'classnames';
import React from 'react';

import './labelValue.scss';

type Props = {
  label: string;
  value: string | number | React.ReactNode;

  className?: string;
  isDate?: boolean;
};

const LabelValue = ({ className, label, value, isDate }: Props) => {
  const displayValue = isDate && value ? formatDateToMMDDYYYY(value) : value;

  const containerStyles = classNames('label-value', className);

  return (
    <div className={containerStyles}>
      <div className='label'>{label}:</div>
      <div className='value'>{displayValue || '-'}</div>
    </div>
  );
};

export default LabelValue;
